import BaseModelAPI from '../BaseModelAPI';

export default class SubcontractGoodReceiptSuggestionDetail extends BaseModelAPI {
	static entity = 'subcontractgoodreceiptsuggestiondetail';
	static entityName = 'subcontractgoodreceiptsuggestiondetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.subcontractGoodReceiptId = '';
			this.subcontractGoodReceipt = {};
			this.controlCardId = '';
			this.controlCard = {};
			this.caseQty = 0;
			this.usedQty = 0;
			this.isScanned = false;
			this.subcontractGoodReceiptDetailId = '';
			this.subcontractGoodReceiptDetail = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.isScanned = '';
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}